export default "<app-menu></app-menu>\n<router-outlet></router-outlet>\n<app-footer></app-footer>\n<app-snack-bar></app-snack-bar>\n<app-loader></app-loader>\n"